//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker
  },
  data: function data() {
    return {
      projectData: {
        user_ids: [],
        group_ids: [],
        client_id: null,
        phases: []
      }
    };
  },
  methods: {
    removePhase: function removePhase(index) {
      this.projectData.phases.splice(index, 1);
    },
    addNewPhase: function addNewPhase() {
      this.projectData.phases.push({
        name: ''
      });
    }
  }
};